import { ReactElement } from 'react';
import { Component as ArrowNextIcon } from 'icons/icon-ui--arrow-next.svg';
import { Component as DiscountIcon } from 'icons/icon-circle--discount.svg';
import styles from '../ProductDisplayPage.module.scss';
import { Button } from '../../shared/button/Button';
import { useMenuWithCart } from '../../../contexts/MenuWithCart';
import { useNavigateWithUTMs } from '../../../hooks/useNavigateWithUTMs';
import { Route } from '../../../utils/config';

type Props = {
  productType: 'Meal_Kit' | 'Ready_to_Eat' | 'Grocery',
  isMobileWidth?: boolean,
}

export function MenuButton({
  productType,
  isMobileWidth = false,
}: Props): ReactElement {
  const { navigate } = useNavigateWithUTMs();
  const { cart } = useMenuWithCart();
  const couponAmount = cart?.priceSummary?.couponAmount || '';

  const CTA_TEXT = {
    Meal_Kit: {
      title: 'Looking to handle dinner or learn a new recipe?',
      subtitle: 'We offer a variety of meal kits, ready to ship to you.',
      buttonText: 'See this week\'s plant-based meal kits',
    },
    Ready_to_Eat: {
      title: 'Looking for a nutritious, convenient, no-prep meal?',
      subtitle: 'We offer a variety of prepared meals, ready to ship to you.',
      buttonText: 'See this week\'s plant-based prepared meals',
    },
    Grocery: {
      title: 'Looking to stock your fridge or pantry?',
      subtitle: 'We offer a variety of artisanal grocery items, ready to ship to you.',
      buttonText: 'See this week\'s plant-based grocery items',
    },
  };

  const handleClick = () => {
    const filterParam = productType.replaceAll('_', '+');
    navigate(`${Route.SHOP}?product_type=${filterParam}`);
    window.scrollTo(0, 0);
  };

  return (
    <div className={styles.prospect_cta}>
      <div style={{ fontWeight: 'bold' }}>{CTA_TEXT[productType]?.title}</div>
      {!isMobileWidth && <div>{CTA_TEXT[productType]?.subtitle}</div>}
      <Button
        text={CTA_TEXT[productType]?.buttonText}
        rightIcon={ArrowNextIcon}
        onClick={handleClick}
        isEnabled
        className={styles.prospect_cta_button}
        style={{ margin: isMobileWidth ? '5px 0' : '12px 0 8px' }}
      />
      {couponAmount && (
        <div className={styles.prospect_discount}>
          <DiscountIcon />
          <div>{`${couponAmount} off your first box.`}</div>
        </div>
      )}
    </div>
  );
}
